// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"HigherOrder__Wrapper","FatArrow":"HigherOrder__FatArrow","Child":"HigherOrder__Child"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HigherOrder/style.scss
// module id = 27
// module chunks = 0